import SpinnerWhite from 'media/icons/spinner-white.png'

export default function OutlineButton({
    size = 'small',
    className = '',
    borderColor = 'border-gray-400',
    textColor = 'text-gray-500',
    text = 'Button Text',
    action = () => { console.log('Add a button action') },
    isLoading = false,
}) {
    return (
        <div> {/* Need this to make sure buttons do not get squished in flex-col */}
            <button 
                className={`
                    ${size === 'large' ? 'w-full h-14 flex items-center justify-center gap-x-4 rounded-2xl text-lg' : ''}
                    ${size === 'small' ? 'w-full h-10 flex items-center justify-center gap-x-2 rounded-2xl text-sm' : ''}
                    ${size === 'extra-small' ? 'w-full h-8 flex items-center justify-center gap-x-2 rounded-xl text-xs' : ''}
                    border ${borderColor} ${textColor} bg-white
                    ${className}
                `}
                onClick={action} 
                disabled={isLoading}
            >
                {!isLoading && (
                    <>
                        {text}
                    </>
                )}

                {isLoading && (
                    <>
                        Loading
                        <img 
                            src={SpinnerWhite} 
                            alt="Spinner" 
                            className={`
                                ${size === 'large' ? 'animate-spin h-4 w-4' : ''}
                                ${size === 'small' ? 'animate-spin h-3 w-3' : ''}
                                ${size === 'extra-small' ? 'animate-spin h-3 w-3' : ''}
                            `}
                        />
                    </>
                )}
            </button>
        </div>
    )
}
